import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { validateAutoGenerateSearch } from "../hooks/useChapterNavigation";

export const Route = createFileRoute(
  "/book/$bookId/content/$partNumber/$chapterNumber",
)({
  component: lazyRouteComponent(
    () => import("../pages/Book/components/ChapterContentPage"),
    "ChapterContentPage",
  ),
  validateSearch: validateAutoGenerateSearch,
});
